var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F389(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1B31C",
    d: "M26.18 20.18l12.57 12.57 12.57 12.57-21.53 8.96-21.53 8.96 8.96-21.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M40 35L25.692 20.67l-9.3 21.87L7.09 64.41z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5A47",
    d: "M15.224 45.285l11.062 11.062-5.531 2.251-7.797-7.797z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M17.343 55.248l3.412 3.35 5.53-2.251-4.8-4.801z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5A47",
    d: "M20.805 32.163l6.696 6.696 11.7 11.7-6.274 2.863-8.171-8.172-6.606-6.605z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M26.537 47.031l6.39 6.39 6.273-2.863-7.838-7.838z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.295,
    cy: 14.458,
    rx: 2,
    ry: 1.971,
    fill: "#8967aa"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.295,
    cy: 18.458,
    rx: 2,
    ry: 1.971,
    fill: "#f1b31c"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.295,
    cy: 39.458,
    rx: 2,
    ry: 1.971,
    fill: "#d22f27"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.663 45.64l.168.168-21.87 9.3L7.09 64.41l9.3-21.87 9.301-21.87M25.801 20.778l12.46 12.46L50.664 45.64M25.692 20.669l.109.109M46.49 7.367c.235.449.403.943.49 1.473.451 2.747-1.447 5.414-4.239 5.957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.933 14.776a4.875 4.875 0 00-1.51.364c-2.569 1.072-3.827 4.093-2.81 6.75M61.793 26.717a4.875 4.875 0 01-.543 1.454c-1.372 2.423-4.523 3.31-7.037 1.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.374 30.256a4.876 4.876 0 00-1.403-.663c-2.673-.778-5.549.787-6.422 3.493"
  }))));
}
export default Svg1F389;